import styles from './Information.module.css';

interface InfoRowProps {
  information?: string;
}

const InfoRow: React.FC<InfoRowProps> = ({ information }) => {
  if (information?.endsWith?.('m2')) {
    const size = Number.parseInt(information.replaceAll('m2', ''));
    return (
      <div className={styles.infoRow}>
        {size ? <>{size + ' m'}&sup2;</> : <span>-</span>}
      </div>
    );
  }
  return <div className={styles.infoRow}>{information}</div>;
};

type InfoType = string | number | string[];

interface InformationProps {
  label: string;
  information: InfoType;
  width?: number;
}

export const Information: React.FC<InformationProps> = ({
  label,
  information,
  width,
}) => {
  let info: JSX.Element | JSX.Element[];

  if (Array.isArray(information) && information.length > 0) {
    info = information.map((info: string, i: number) => (
      <InfoRow key={'i' + i} information={info} />
    ));
  } else if (Array.isArray(information) || !information) {
    info = <InfoRow information="-" />;
  } else {
    info = <InfoRow information={information as string} />;
  }

  return (
    <div
      className={styles.information}
      style={{
        width: (width || 1) * 20 + '%',
      }}
    >
      <div className={styles.label}>{label}</div>
      {info}
    </div>
  );
};
